(function () {
  var C = {
    'black':'#111111','white':'#FFFFFF','solid white blend':'#F4F4F2','red':'#C8102E','maroon':'#5B1A28','navy':'#1F2A44','true navy':'#2A3555','heather navy':'#3A4460',
    'blue':'#2D5DA8','royal':'#2B4FA8','royal caribe':'#3A6EA5','light blue':'#A9C8E4','ice blue':'#BFD6E6','heather ice blue':'#B8D0E0','stone blue':'#7E95A8','blue jean':'#5E7A96','chambray':'#A9C1D6','denim':'#4F6B8A','flo blue':'#6E8FD6','lagoon blue':'#7FC7D9','sapphire':'#0F7FB0','sky':'#A7CDE8','turquoise':'#2BB3B1',
    'green':'#2E7D4F','light green':'#9DBF8E','forest':'#234D35','kelly':'#2A9D4B','military green':'#5B6340','olive':'#6B6B3A','sage':'#A8B59A','seafoam':'#8FC1B5','mint':'#B8E2CF','chalky mint':'#A8DCC8','island reef':'#9ED7C5','teal':'#2A7C7C','bay':'#B9C4AE',
    'grey':'#8E8E8E','gray':'#8E8E8E','sport grey':'#9B9B9B','dark grey':'#4F4F4F','dark grey heather':'#555559','dark heather':'#4A4D52','charcoal':'#3E3E3E','graphite':'#4A4B4D','granite':'#8B8C89','pepper':'#4F4C4A','ash':'#D3D3D0','heather':'#A6A6A6','athletic heather':'#B5B5B5',
    'yellow':'#F2C230','gold':'#D4A017','butter':'#F4E3A1','orange':'#F07C24','neon red orange':'#FF5A36','burnt orange':'#C1581E','melon':'#F6A27B','peachy':'#F6C3A5','heather peach':'#F3B9A0','terracotta':'#C8775A',
    'pink':'#F2A7C1','light pink':'#F6CFDC','blossom':'#F4B6C8','bright salmon':'#F08C76','salmon':'#F4A08C','coral':'#F27C6B','watermelon':'#E85C6E','crunchberry':'#E0457B','crimson':'#B23A48','heather red':'#C2414B',
    'purple':'#6A4C93','heather purple':'#7E6AA8','violet':'#8E7FC1','violet blossom':'#9E86C2','lavender':'#C9B8E6','orchid':'#C9A3C8','grape':'#5B3F7A',
    'brown':'#6B4423','espresso':'#4A3328','chocolate':'#4E3524','dark chocolate':'#3B2A24','brick':'#8E3B2E','chili':'#A23A2A','cardinal':'#9E1B32','burgundy':'#6D1F2F','berry':'#8A2846',
    'khaki':'#B9A77F','sand':'#D8C8A8','sandstone':'#C8B49A','tan':'#C9A97E','beige':'#E3D5BC','natural':'#EFE6D2','ivory':'#F5F0E1','cream':'#F3EAD3','bone':'#E8E0CF','silver':'#C0C0C0'
  };
  var KEYS = Object.keys(C).sort(function (a, b) { return b.length - a.length; });
  function hexFor(name) {
    var n = (name || '').toLowerCase().split(/[ ]+/).join(' ').trim();
    if (C[n]) return C[n];
    var words = n.split(' ');
    for (var w = words.length - 1; w >= 0; w--) { if (C[words[w]]) return C[words[w]]; }
    for (var i = 0; i < KEYS.length; i++) { if (n.indexOf(KEYS[i]) !== -1) return C[KEYS[i]]; }
    return null;
  }
  function variants(root) {
    root.querySelectorAll('.variant-option--buttons').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg) return;
      var isColor = /colou?r/i.test(lg.textContent);
      var isSize = /size|talla/i.test(lg.textContent);
      if (isSize && !lg.dataset.pg) { lg.dataset.pg = '1'; if (lg.firstChild && lg.firstChild.nodeType === 3) { lg.firstChild.nodeValue = 'Elige tu talla'; } else { lg.insertBefore(document.createTextNode('Elige tu talla'), lg.firstChild); } }
      if (!isColor) return;
      var checked = null;
      fs.querySelectorAll('.variant-option__button-label').forEach(function (lb) {
        var inp = lb.querySelector('input');
        if (!inp) return;
        if (inp.checked) checked = inp.value;
        if (lb.classList.contains('pg-sw')) return;
        var hx = hexFor(inp.value);
        if (hx) { lb.classList.add('pg-sw'); lb.style.setProperty('--sw', hx); lb.title = inp.value; }
      });
      var sel = lg.querySelector('.pg-sel');
      if (!sel) { sel = document.createElement('span'); sel.className = 'pg-sel'; lg.appendChild(sel); }
      if (checked && sel.textContent !== checked) sel.textContent = checked;
    });
  }
  var desktop = window.matchMedia('(min-width: 750px)');
  function bars(root) {
    var comp = root.querySelector('.media-gallery--carousel slideshow-component');
    if (!comp) return;
    var q = desktop.matches ? '.slideshow-controls__thumbnail' : '.slideshow-controls__dots button';
    var list = Array.prototype.slice.call(comp.querySelectorAll(q));
    if (!list.length) list = Array.prototype.slice.call(comp.querySelectorAll('.slideshow-controls__thumbnail, .slideshow-controls__dots button'));
    list = list.filter(function (b) { return !b.closest('[hidden]'); });
    var n = list.length;
    var wrap = comp.querySelector(':scope > .pg-bars');
    if (n < 2) { if (wrap) wrap.remove(); return; }
    var idx = 0;
    list.forEach(function (b, i) { if (b.getAttribute('aria-selected') === 'true') idx = i; });
    var single = n > 10;
    var need = single ? 1 : n;
    if (!wrap || wrap.children.length !== need || wrap.classList.contains('pg-bars--single') !== single) {
      if (wrap) wrap.remove();
      wrap = document.createElement('div');
      wrap.className = 'pg-bars' + (single ? ' pg-bars--single' : '');
      wrap.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < need; i++) {
        var s = document.createElement('span');
        if (!single) { (function (k) { s.addEventListener('click', function () { var l = comp.querySelectorAll(q); if (l[k]) l[k].click(); }); })(i); }
        wrap.appendChild(s);
      }
      comp.insertBefore(wrap, comp.firstChild);
    }
    if (single) { wrap.firstChild.style.setProperty('--pg-p', ((idx + 1) / n).toFixed(3)); }
    else { Array.prototype.forEach.call(wrap.children, function (s, i) { var on = i <= idx; if (s.classList.contains('on') !== on) s.classList.toggle('on', on); }); }
  }
  function run() { document.querySelectorAll('.product-information').forEach(function (r) { variants(r); bars(r); }); }
  function boot() {
    run();
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); });
    document.querySelectorAll('.product-information').forEach(function (r) { mo.observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'checked', 'hidden'] }); });
    document.addEventListener('change', function () { setTimeout(run, 30); });
    if (desktop.addEventListener) desktop.addEventListener('change', run);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();